'use strict';

class Label extends Widget {
  _element: any;

  constructor(element: any) {
    super(element);
  }

  clear() {
    this.html('');
  }

  text(text: any) {
    if (text === undefined) {
      return this._element.text();
    } else {
      this._element.text(text);
    }
  }

  html(html: any) {
    if (html === undefined) {
      return this._element.html();
    } else {
      this._element.html(html);
    }
  }

  prepend(html: any) {
    this._element.prepend(html);
  }

  append(html: any) {
    this._element.append(html);
  }

  scrollToBottom() {
    this._element.prop('scrollTop', this._element.prop('scrollHeight'));
  }

  static Create() {
    return $('<div class="label" />');
  }
}

ui.Label = Label;
ui.label = ui.widgetConstructor('label', ui.Label);
